module.exports = {"441821100":"石角镇","441821101":"水头镇","441821102":"汤塘镇","441821103":"龙山镇","441821104":"高岗镇","441821107":"迳头镇","441821400":"清远市羊角山林场","441821401":"广东佛冈观音山省级自然保护区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/441821.json
// module id = 2174
// module chunks = 0